export default "__VITE_ASSET__B0YB4xhL__"